export default __webpack_public_path__ + "static/media/paint.8639731b.png";